import *  as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useAtom, atom } from 'jotai';
import { AnimatePresence, motion } from 'framer-motion';
import { imgMove, sceneAtom, currentUrl, selectedName } from "../data/AtomData";
import sidebarData from "../data/sidebarData";


interface MainImageProps { }

export const MainImage: React.FC<MainImageProps> = (props: React.PropsWithChildren<MainImageProps>) => {
	const [scene, setScene] = useAtom(sceneAtom);
	const [activeUrl, setActiveUrl] = useAtom(currentUrl);
	const [currentNames, setCurrentNames] = useAtom(selectedName);
	const [currentImages, setCurrentImages] = useState<{ [index: string]: string }>({});
	const hasRefreshed = useRef(false);

	useEffect(() => {
		const newImages: { [index: string]: string } = {
			"Background": `Main_Images/Background_Layer.png`,
			"Door": `Main_Images/Cab_Fronts/${scene["Door Range"][0]}/${scene["Handle Shape"][0]}/Cab_Front--${scene["Door Range"][0]}-${scene["Handle Shape"][0]}-${scene["Door Colour"][0]}.png`,
			"Backplate": `Main_Images/Backplates/${scene["Door Range"][0]}/${scene["Handle Shape"][0]}/Backplate--${scene["Door Range"][0]}-${scene["Handle Shape"][0]}-${scene["Backplate Finish"][0]}.png`,
			"Worksurface": `Main_Images/Worksurface/${scene["Worksurface"][0]}.png`,
			"Prop": `Main_Images/Prop_Layer.png`,
		};

		try {
			const updatedImages: { [index: string]: string } = {};
			Object.entries(newImages).forEach(([key, value]) => {
				updatedImages[key] = require(`../img/${value}`);
			});
			setCurrentImages(updatedImages);
		} catch (error) {
			console.error("Error loading images:", error);
		}
	}, [scene]);

	//TEMPORARY SOLUTION IF THE HANDLE ISNT AVAILABLE

	useEffect(() => {
		const selectedRange = sidebarData.find(item =>
			item.subMenu.some(subItem => subItem.text === currentNames[0])
		)?.subMenu.find(subItem => subItem.text === currentNames[0]);

		if (selectedRange) {
			const handleType = scene["Handle Shape"][0];
			const isHandleAvailable =
				(handleType === "Edge" && selectedRange.hasEdge) ||
				(handleType === "Portal" && selectedRange.hasPortal) ||
				(handleType === "Channel" && selectedRange.hasChannel) ||
				(handleType === "Extended_Channel" && selectedRange.hasExChannel);

			if (!isHandleAvailable) {
				setActiveUrl(prev => ({
					...prev,
					handleShape: "hs1"
				}));

				const currentUrl = window.location.pathname;
				const updatedUrl = currentUrl.replace(/hs\d+/, "hs1");

				window.history.replaceState(null, "", updatedUrl);

				hasRefreshed.current = true;

				window.location.reload();
			}
		}
	}, [currentNames[0], currentNames[2], scene["Handle Shape"], setScene]);

	//TEMPORARY SOLUTION IF THE HANDLE ISNT AVAILABLE

	const cabRange = activeUrl.cabRange;
	useEffect(() => {
		for (let i = 0; i <= sidebarData[1].subMenu.length; i++) {
			const webCode = sidebarData[1].subMenu[i]?.webCode;

			if (cabRange === webCode) {
				const imgCode = sidebarData[1].subMenu[i].imagePart;
				const nameCode = sidebarData[1].subMenu[i]?.text;
				setCurrentNames(names => names.map((item, index) => index === 0 ? nameCode : item))
				setScene(prevScene => ({
					...prevScene,
					"Door Range": [imgCode || '']
				}));
				break;
			}
		}
	}, [cabRange, setScene]);

	const cabCol = activeUrl.cabCol;
	useEffect(() => {
		for (let i = 0; i <= sidebarData[2].subMenu.length; i++) {
			const childSubMenuLength = sidebarData[2]?.subMenu[i]?.childSubMenu;

			if (childSubMenuLength !== undefined) {
				for (let c = 0; c < childSubMenuLength.length; c++) {
					const webCode = childSubMenuLength[c]?.webCode;
					if (cabCol === webCode) {
						const imgCode = childSubMenuLength[c].imagePart;
						const nameCode = childSubMenuLength[c]?.text;
						setCurrentNames(names => names.map((item, index) => index === 1 ? nameCode : item))
						setScene(prevScene => ({
							...prevScene,
							"Door Colour": [imgCode || '']
						}));
						break;
					}
				}
			}
		}
	}, [cabCol, setScene]);

	const hanShap = activeUrl.handleShape;
	useEffect(() => {
		for (let i = 0; i <= sidebarData[2].subMenu.length; i++) {
			const childSubMenuLength = sidebarData[2]?.subMenu[i]?.childSubMenu;

			if (childSubMenuLength !== undefined) {
				for (let c = 0; c < childSubMenuLength.length; c++) {
					const webCode = childSubMenuLength[c]?.webCode;
					if (hanShap === webCode) {
						const imgCode = childSubMenuLength[c].imagePart;
						const nameCode = childSubMenuLength[c]?.text;
						setCurrentNames(names => names.map((item, index) => index === 2 ? nameCode : item))
						setScene(prevScene => ({
							...prevScene,
							"Handle Shape": [imgCode || '']
						}));
						break;
					}
				}
			}
		}
	}, [hanShap, setScene]);

	const backP = activeUrl.backplate;
	useEffect(() => {
		for (let i = 0; i <= sidebarData[2].subMenu.length; i++) {
			const childSubMenuLength = sidebarData[2]?.subMenu[i]?.childSubMenu;

			if (childSubMenuLength !== undefined) {
				for (let c = 0; c < childSubMenuLength.length; c++) {
					const webCode = childSubMenuLength[c]?.webCode;
					if (backP === webCode) {
						const imgCode = childSubMenuLength[c].imagePart;
						const nameCode = childSubMenuLength[c]?.text;
						setCurrentNames(names => names.map((item, index) => index === 3 ? nameCode : item))
						setScene(prevScene => ({
							...prevScene,
							"Backplate Finish": [imgCode || '']
						}));
						break;
					}
				}
			}
		}
	}, [backP, setScene]);

	const worksurf = activeUrl.worksurface;
	useEffect(() => {
		for (let i = 0; i <= sidebarData[2].subMenu.length; i++) {
			const childSubMenuLength = sidebarData[2]?.subMenu[i]?.childSubMenu;

			if (childSubMenuLength !== undefined) {
				for (let c = 0; c < childSubMenuLength.length; c++) {
					const webCode = childSubMenuLength[c]?.webCode;
					if (worksurf === webCode) {
						const imgCode = childSubMenuLength[c].mainImg;
						const nameCode = childSubMenuLength[c]?.text;
						setCurrentNames(names => names.map((item, index) => index === 4 ? nameCode : item))
						setScene(prevScene => ({
							...prevScene,
							"Worksurface": [imgCode || '']
						}));
						break;
					}
				}
			}
		}
	}, [worksurf, setScene]);

	return (<>
		<div className="configurator">
			{Object.entries(currentImages).map(([name, img], index) => (
				index === 2 ? (
					<AnimatePresence mode="sync">
						<motion.img
							key={img}
							src={img}
							alt={name}
							style={{ zIndex: index + 2 }}
							initial={{ opacity: 1 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							transition={{ duration: 0.2 }}
						/>
					</AnimatePresence>
				) : (
					<AnimatePresence mode="sync">
						<motion.img
							key={img}
							src={img}
							alt={name}
							style={{ zIndex: index + 2 }}
								initial={{ opacity: 0.5 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0.5 }}
								transition={{ duration: 0.6 }}
						/>
					</AnimatePresence>)
			))}
		</div>
	</>);
}